// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".U6kiy15FSzo6z3GmQt0C4A\\=\\={color:var(--color-primary);background:var(--color-primary-bg)}", "",{"version":3,"sources":["webpack://./components/Avatar/styles.module.scss"],"names":[],"mappings":"AAAA,4BACE,0BAAA,CACA,kCAAA","sourcesContent":[".avatar {\n  color: var(--color-primary);\n  background: var(--color-primary-bg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar": "U6kiy15FSzo6z3GmQt0C4A=="
};
export default ___CSS_LOADER_EXPORT___;
